module.exports = __webpack_public_path__ + "img/1537036619.615808a9.jpg";